import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { AddTransactionMapPayload, AddTransactionMapInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_ADD_MAP = gql`
    mutation addMap($input: AddTransactionMapInput!){
        addTransactionMap(input: $input){
            message
            errors {
                code
                message
            }
            result
            transactionMapId
        }
    }
`;

export const mutationAddMap = async (
    client: ApolloClient<NormalizedCacheObject>,
    dataToAdd: AddTransactionMapInput
): Promise<AddTransactionMapPayload | undefined> => {
    const { transactionId, description, documentString, sourceFileName, versionComment, standardVersion } = dataToAdd;
    const { data, errors } = await client.mutate<{ addTransactionMap: AddTransactionMapPayload}>({
        variables: { 
            input: { 
                description, 
                documentString,
                sourceFileName,
                versionComment, 
                standardVersion, 
                transactionId, 
            } 
        },
        mutation: MUTATION_ADD_MAP
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred while adding the transaction map.');
    }
    if (data && data.addTransactionMap) {
        return data.addTransactionMap;
    }

    return undefined;
};